import { Component, OnInit, inject } from "@angular/core";
import { DataAccessService } from "../core/services/data-access.service";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog, MatDialogTitle, MatDialogContent, MatDialogActions } from "@angular/material/dialog";
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from "@angular/material/table";
import { ISimpleListElement } from "../core/models/ISimpleListElement";
import Swal from "sweetalert2";
import { IClaim } from "../core/models/IClaim";
import { UploadService } from "../core/services/upload-service";
import { AttachmentDialog } from "./attachment_dialog";
import { Router } from "@angular/router";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatSort, MatSortHeader } from "@angular/material/sort";
import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { FormsModule } from "@angular/forms";

@Component({
    selector: "proceed_claim_dialog",
    templateUrl: "proceed_claim_dialog.html",
    styleUrls: ["./claim_edit.scss"],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatButton, MatIcon, MatFormField, MatLabel, MatInput, FormsModule, MatDialogActions]
})
export class ProceedClaimDialog implements OnInit {
  dialogRef = inject<MatDialogRef<ProceedClaimDialog>>(MatDialogRef);
  data = inject<object>(MAT_DIALOG_DATA);
  dialog = inject(MatDialog);
  private dataAccess = inject(DataAccessService);
  private router = inject(Router);

  displayedColumns: string[] = [
    "claim_no",
    "claim_status",
    "claimed_qty",
    "claimed_cost",
    "manual_claimed_cost",
    "claim_reason_code",
    "customers_comments",
    "suppliers_comments",
    "suggested_actions",
  ];
  dataSource: MatTableDataSource<IClaim>;
  line: IClaim;
  lines: IClaim[];
  cancelReasons: ISimpleListElement[];
  operation = "";
  title = "";
  message = "";
  showCancelReasonCodes = false;
  cancelReason: string;
  comments: string;
  isSupplier: boolean;
  isCustomer: boolean;
  nextStatus: string;
  proceedComments: any;
  attachments: any;
  showWarning = true;

  constructor() {
    const data = this.data;

    this.lines = (data as any).lines;
    this.line = this.lines[0];
    this.operation = (data as any).operation;
    this.showWarning = (data as any).showWarning;

    const role = (this.dataAccess.getLoginData() as any)
      ? (this.dataAccess.getLoginData() as any).roles.filter(
          (x) => x.id == (this.dataAccess.getLoginData() as any).user_role_id
        )[0]
      : null;
    this.isSupplier = role ? role.is_supplier : false;
    this.isCustomer = role ? role.is_customer : false;

    if (this.operation == "accept") {
      switch (this.line.claim_status) {
        case "CR":
          this.nextStatus = "NW";
          break;
        case "NW":
          this.nextStatus = "AC-GA";
          break;
        case "AC-GA":
          this.nextStatus = "AC";
          break;
        case "AC-P":
          this.nextStatus = "AC-GA";
          break;
        case "RJ-GA":
          this.nextStatus = "RJ";
          break;
      }
    } else if (this.operation == "reject") {
      switch (this.line.claim_status) {
        case "NW":
          this.nextStatus = "RJ-GA";
          break;
        case "RJ-GA":
          this.nextStatus = "CR";
          break;
        case "AC-GA":
          this.nextStatus = "AC-P";
          break;
      }
    }

    let action =
      this.line.claim_status == "CR"
        ? this.operation == "accept"
          ? "release"
          : "delete"
        : this.operation;

    if (this.operation == "accept" && this.line.claim_status == "RJ-GA") {
      action = "accept rejection of";
    }

    this.title =
      action[0].toUpperCase() +
      action.slice(1) +
      " the claim" +
      (this.nextStatus
        ? " (" + this.line.claim_status + "->" + this.nextStatus + ")"
        : "");
    this.message = "Do you want to " + action + " this claim?";
  }

  ngOnInit() {
    this.refreshAttachments();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onOkClick(operation: string): void {
    this.dataAccess
      .getJSONPost(
        "proceed_with_claim",
        [],
        [
          { k: "p_id", v: this.line.id },
          { k: "p_action", v: this.operation },
          { k: "p_comments", v: this.line.suppliers_comments },
        ]
      )
      .then((data) => {
        if (data.res != 0) {
          Swal.fire("Error!", data.msg, "error");
        } else if (data.msg == "Claim deleted.") {
          Swal.fire({
            icon: "success",
            title: "Claim deleted",
            showConfirmButton: false,
            timer: 800,
            willClose: () => {
              this.dialogRef.close();
              this.router.navigate(["/claims"]);
            },
          });
        } else {
          Swal.fire({
            icon: "success",
            title: "Claim proceeded",
            showConfirmButton: false,
            timer: 1000,
            willClose: () => {
              this.dialogRef.close();
            },
          });
        }
      });
  }

  public refreshAttachments() {
    this.dataAccess
      .getJSONPost(
        "get_claim_attachments",
        [],
        [
          { k: "p_claim_id", v: this.line.id },
          { k: "p_category", v: "supplier" },
        ]
      )
      .then((data) => {
        this.attachments = Array.isArray(data) ? data : [];
      });
  }

  showSelectAttachmentDialog() {
    document.getElementById("attachmentUpload").click();
  }

  deleteAttachment(e, id: number) {
    e.preventDefault();

    const dialogDel = this.dialog.open(AttachmentDialog, {
      data: { id: id, action: "delete" },
    });

    dialogDel.afterClosed().subscribe((result) => {
      this.refreshAttachments();
    });
  }
}
